import axios from "axios";
import { Formik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { Col, Row, Input, Button, Form, Label } from "reactstrap";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { Redirect, useHistory, useParams } from "react-router-dom";
import { UserConsumer } from "../../../UserContext";
import { ItemRequisitionAPI } from "../ItemRequisitionAPI";
import { AlertPopups } from "../../../components/AlertPopups";
import VendorQuotations from "./VendorQuotations";
import TagAssets from "./TagAssets";
import CustomReactSelect from "../../../components/CustomReactSelect";
import FormStatus from "../../../components/FormStatus";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import FormHeaderButton from "./FormHeaderButton";
import ItemReceivingForm from "./ItemReceivingForm";
import CMApprovalForm from "../CM/CMApprovalForm";
import { Routes } from "../../../configurations/config";

// Initialize pdfMake fonts
if (pdfFonts && pdfFonts.pdfMake && pdfFonts.pdfMake.vfs) {
	pdfMake.vfs = pdfFonts.pdfMake.vfs;
}

function SSNItemRequisitionDetail() {
	let token = null;
	const { id } = useParams();
	const history = useHistory();
	const itemStatus = null;
	const [formItemStatus, setFormItemStatus] = useState(itemStatus);
	const [apiHeaderToken, setApiHeaderToken] = useState(null);
	const [ItemRequisitionDetail, setItemRequisitionDetail] = useState({});
	const [showVendorQuotations, setShowVendorQuotations] = useState(null);
	const [inStock, setInStock] = useState(null);
	const [supervisorComments, setSupervisorComments] = useState("");
	//Kashif Flow
	const [requestTypesList, setRequestTypesList] = useState(null);
	const [selectedRequestedType, setSelectedRequestType] = useState(null);
	const [itemCategoryList, setItemCategoryList] = useState(null);
	const [selectedItemCategory, setSelectedItemCategory] = useState();
	const [adminSupportApprovalTypesList, setAdminSupportApprovalTypes] =
		useState(null);
	const [
		selectedAdminSupportApprovalType,
		setSelectedAdminSupportApprovalType,
	] = useState(null);
	const [vendorByCategoryList, setVendorByCategoryList] = useState(null);
	const [selectedVendor, setSelectedVendor] = useState(null);
	const [selectedTagAssetCategory, setSelectedTagAssetCategory] =
		useState(null);
	const [tagAssetCode, setTagAssetCode] = useState("");
	const [vendorQualificationRemarks, setVendorQualificationRemarks] =
		useState(null);
	const [showVendorModal, setShowVendorModal] = useState(false);
	const [showTagAssetModal, setShowTagAssetModal] = useState(false);
	const [isVendorLoaded, setIsVendorLoaded] = useState(false);
	const [isTagAssetLoaded, setIsTagAssetLoaded] = useState(false);

	const validate = Yup.object().shape({
		requestType: Yup.object().shape({
			label: Yup.string().required("Required"),
			value: Yup.string().required("Required"),
		}),
		adminSupportApproval: Yup.object().shape({
			label: Yup.string().required("Required"),
			value: Yup.string().required("Required"),
		}),
	});

	useEffect(() => {
		const tokenHeader = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(
				`${ItemRequisitionAPI.GetItemRequisitionRequestDetailById}/${id}`,
				{
					headers: tokenHeader,
				}
			)
			.then(({ status, data }) => {
				if (status === 200) {
					setFormItemStatus(data.itemRequisitionStatus);
					setItemRequisitionDetail(data);
				}
			});
		setApiHeaderToken(tokenHeader);
		getItemRecievingTypes();
		getItemRequisitionSectionDetail();
		if (formItemStatus === null)
			setFormItemStatus(JSON.parse(sessionStorage.getItem("itemStatus")));
		else sessionStorage.setItem("itemStatus", JSON.stringify(itemStatus));
	}, []);

	useEffect(() => {
		const tokenHeader = {
			Authorization: `Bearer ${token}`,
		};
		//-------Kashif Flow
		axios
			.get(`${ItemRequisitionAPI.GetRequestTypes}`, {
				headers: tokenHeader,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					setRequestTypesList(
						data.types.sort((a, b) =>
							a.label.localeCompare(b.label)
						)
					);
				}
			});
		getCategoriesAndRespondingVendors();
		axios
			.get(`${ItemRequisitionAPI.GetAdminSupportApprovalTypes}`, {
				headers: tokenHeader,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					setAdminSupportApprovalTypes(
						data.approvalTypes.sort((a, b) =>
							a.label.localeCompare(b.label)
						)
					);
				}
			});
	}, [ItemRequisitionDetail]);

useEffect(() => {
	if (typeof selectedItemCategory !== 'undefined') {
		getRespondingVendors(selectedItemCategory);
	}
  // Call the method when any of the dependency values change
}, [ selectedItemCategory]);

	useEffect(() => {
		getRelevantDepartmentDetail();
	}, [requestTypesList]);

	const getRelevantDepartmentDetail = () => {
		axios
			.get(
				`${ItemRequisitionAPI.GetRelevantDepartment}/${id}/SupportDepartment`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then(({ status, data }) => {
				if (status === 200) {
					const ReqType = requestTypesList?.find((item) => {
						return data.requestType === item.value;
					});
					setSelectedRequestType(ReqType);
					const category = itemCategoryList?.find((item) => {
						return data.itemCategoryId === item.value;
					});
					setSelectedItemCategory(category);
					const adminSupportApprov =
						adminSupportApprovalTypesList?.find((item) => {
							return data.adminSupportApproval === item.value;
						});

					setSelectedAdminSupportApprovalType(adminSupportApprov);
					setInStock(data.inStock);
					setShowVendorQuotations(!data.inStock);
					setSupervisorComments(data.adminSupportComments);
					setVendorQualificationRemarks(
						data.vendorQualificationRemarks
					);
				}
			});
	};

	const getCategoriesAndRespondingVendors = async () => {
		const tokenHeader = {
			Authorization: `Bearer ${token}`,
		};
		const categoryValue = await axios
			.get(`${ItemRequisitionAPI.GetCategories}`, {
				headers: tokenHeader,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					setItemCategoryList(data.categories);
					setSelectedItemCategory(data.categories[0]);
					return data.categories[0].value;
				}
			});

		await axios
			.get(
				`${ItemRequisitionAPI.GetVendorByCategoryId}/${categoryValue}/Vendors`,
				{
					headers: tokenHeader,
				}
			)
			.then(({ status, data }) => {
				if (status === 200) {
					setVendorByCategoryList(data.vendorList);
					setSelectedVendor(data.vendorList[0]);
				}
			});
	};
	const getRespondingVendors = (value) => {
		setSelectedItemCategory(value);
		axios
			.get(
				`${ItemRequisitionAPI.GetVendorByCategoryId}/${value.value}/Vendors`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then(({ status, data }) => {
				if (status === 200) {
					setVendorByCategoryList(data.vendorList);
					setSelectedVendor(data.vendorList[0]);
				}
			});
	};

	const onTagAssetCategoryChange = (value) => {
		setSelectedItemCategory(value);
		setSelectedTagAssetCategory(value);
		axios
			.get(
				`${ItemRequisitionAPI.GetTagAssetByCategoryId}/${value.value}/GenerateCode`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then(({ status, data }) => {
				if (status === 200) {
					setTagAssetCode(data.assetTag);
				}
			});
	};
	const handleRelevantDeptUpdate = () => {
		if (
			selectedItemCategory === null ||
			selectedItemCategory === undefined
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Select Item Category",
			});
		} else {
			const formBody = {
				requestType: selectedRequestedType.value,
				itemCategory: selectedItemCategory.value,
				inStock: !showVendorQuotations,
				approvalStatus: selectedAdminSupportApprovalType.value,
				departmentComments: supervisorComments,
				vendorQualificationRemarks: vendorQualificationRemarks,
			};

			axios
				.put(
					`${ItemRequisitionAPI.updateRelevantDepartment}/${id}/SupportDepartment`,
					formBody,
					{
						headers: apiHeaderToken,
					}
				)
				.then(({ status, message }) => {
					if (status === 200) {
						AlertPopups.successAlert.fire({
							text: "Updated",
						});
						window.location.reload();
					} else if (status === 400) {
						AlertPopups.ErrorAlert.fire({
							text: message,
						});
					}
				})
				.catch((error) => {
					if (error.response)
						AlertPopups.ErrorAlert.fire({
							text: error.response.data.message,
						});
				});
		}
	};
	//Item Receiving Form
	const [ItemReceivingTypes, setItemReceivingTypes] = useState(null);
	const [formFields, setFormFields] = useState({
		receivingComments: "",
		inspectionDetail: "",
		receiviedStatus: "",
	});
	useEffect(() => {
		axios
			.get(
				`${ItemRequisitionAPI.GetReceivingSection}/${id}/GetReceivingSection`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then(({ data }) => {
				setFormFields({
					receivingComments: data.receivedComments,
					inspectionDetail: data.inspectionDetails,
					receiviedStatus: {
						value: data.receivedStatus,
						label: data.receivedStatus,
					},
				});
			});
	}, []);

	const [itemReceivingSection, setItemReceivingSection] = useState([]);

	const itemHandleChange = (e) => {
		setFormFields({ ...formFields, [e.target.name]: e.target.value });
	};
	const getItemRecievingTypes = () => {
		axios
			.get(`${ItemRequisitionAPI.GetItemReceivingTypes}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then(({ data }) => {
				setItemReceivingTypes(data.statusTypes);
			});
	};
	const getItemRequisitionSectionDetail = () => {
		id != null &&
			axios
				.get(
					`${ItemRequisitionAPI.GetReceivingSection}/${id}/GetReceivingSection`,
					{ headers: { Authorization: `Bearer ${token}` } }
				)
				.then(({ data }) => {
					setItemReceivingSection(data);
				});
	};
	const handleStatus = (obj) => {
		setFormFields({
			...formFields,
			["receiviedStatus"]: { value: obj.value, label: obj.label },
		});
	};
	const updateItemReceivingSection = () => {
		const body = {
			receivedComments: formFields.receivingComments,
			inspectionDetails: formFields.inspectionDetail,
			receivedStatus: formFields.receiviedStatus.value,
		};
		axios
			.post(
				`${ItemRequisitionAPI.GetReceivingSection}/${id}/GetReceivingSection`,
				body,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then(() => {
				getItemRequisitionSectionDetail();
				AlertPopups.successAlert.fire({
					text: "Updated",
				});
				window.location.reload();
			});
	};

	const handleDownloadPDF = async () => {
		try {
			// Ensure fonts are loaded
			if (pdfFonts && pdfFonts.pdfMake && pdfFonts.pdfMake.vfs) {
				pdfMake.vfs = pdfFonts.pdfMake.vfs;
			}

			const tokenHeader = { Authorization: `Bearer ${token}` };

			// Fetch vendor quotations
			let vendorQuotationsData = [];
			if (showVendorQuotations) {
				try {
					const quotRes = await axios.get(
						`${ItemRequisitionAPI.GetVendorQuotationsList}/${id}/VendorQuotations?PageSize=1000`,
						{ headers: tokenHeader }
					);
					vendorQuotationsData = quotRes.data.quotations || [];
				} catch (error) {
					console.error("Error fetching vendor quotations:", error);
				}
			}

			// Fetch tag assets - always fetch, don't depend on selectedItemCategory
			let tagAssetsData = [];
			try {
				const assetsRes = await axios.get(
					`${ItemRequisitionAPI.GetTagAssetsList}/${id}/TagAssets?PageSize=1000`,
					{ headers: tokenHeader }
				);
				// Response is directly an array
				tagAssetsData = assetsRes.data.tagAssets ? assetsRes.data.tagAssets : [];

			} catch (error) {
				console.error("Error fetching tag assets:", error);
			}

			// Build PDF content
			const docContent = [];

			// Header
			docContent.push({
				text: "ITEM REQUISITION DETAIL",
				fontSize: 16,
				bold: true,
				alignment: "center",
				marginBottom: 20,
			});

			// Personal Information Section
			docContent.push({
				text: "Personal Information",
				fontSize: 12,
				bold: true,
				marginTop: 15,
				marginBottom: 10,
			});
			docContent.push({
				layout: "lightHorizontalLines",
				table: {
					widths: ["50%", "50%"],
					body: [
						[
							{ text: "Employee Name", bold: true },
							ItemRequisitionDetail.employeeName || "",
						],
						[
							{ text: "Employee Code", bold: true },
							ItemRequisitionDetail.employeeCode || "",
						],
						[
							{ text: "Department", bold: true },
							ItemRequisitionDetail.department || "",
						],
						[
							{ text: "Date", bold: true },
							moment(ItemRequisitionDetail.date).format(
								"DD/MM/YYYY"
							) || "",
						],
					],
				},
				marginBottom: 15,
			});

			// Request Details Section
			docContent.push({
				text: "Request Details",
				fontSize: 12,
				bold: true,
				marginTop: 15,
				marginBottom: 10,
			});
			docContent.push({
				layout: "lightHorizontalLines",
				table: {
					widths: ["50%", "50%"],
					body: [
						[
							{ text: "Project/Department Name", bold: true },
							ItemRequisitionDetail.projectName || "",
						],
						[
							{ text: "Item", bold: true },
							ItemRequisitionDetail.item || "",
						],
						[
							{ text: "Priority", bold: true },
							ItemRequisitionDetail.priority || "",
						],
						[
							{ text: "Request Type", bold: true },
							selectedRequestedType?.label || "",
						],
						[
							{ text: "Description", bold: true },
							ItemRequisitionDetail.description || "",
						],
						[
							{ text: "Justification", bold: true },
							ItemRequisitionDetail.justification || "",
						],
					],
				},
				marginBottom: 15,
			});

			// Departmental Details Section
			docContent.push({
				text: "Departmental Details",
				fontSize: 12,
				bold: true,
				marginTop: 15,
				marginBottom: 10,
			});
			docContent.push({
				layout: "lightHorizontalLines",
				table: {
					widths: ["50%", "50%"],
					body: [
						[
							{ text: "Category", bold: true },
							selectedItemCategory?.label || "",
						],
						[
							{ text: "Approval Type", bold: true },
							selectedAdminSupportApprovalType?.label || "",
						],
						[
							{ text: "In Stock", bold: true },
							inStock?.label || "",
						],
						[
							{ text: "Vendor", bold: true },
							selectedVendor?.label || "",
						],
						[
							{ text: "Supervisor Comments", bold: true },
							supervisorComments || "",
						],
						[
							{ text: "Vendor Qualification Remarks", bold: true },
							vendorQualificationRemarks || "",
						],
					],
				},
				marginBottom: 15,
			});

			// Item Receiving Section
			docContent.push({
				text: "Item Receiving Details",
				fontSize: 12,
				bold: true,
				marginTop: 15,
				marginBottom: 10,
			});
			docContent.push({
				layout: "lightHorizontalLines",
				table: {
					widths: ["50%", "50%"],
					body: [
						[
							{ text: "Received Status", bold: true },
							formFields.receiviedStatus?.label || "",
						],
						[
							{ text: "Inspection Details", bold: true },
							formFields.inspectionDetail || "",
						],
						[
							{ text: "Receiving Comments", bold: true },
							formFields.receivingComments || "",
						],
					],
				},
				marginBottom: 15,
			});

			// Vendor Quotations Section
			if (vendorQuotationsData.length > 0) {
				docContent.push({
					text: "Vendor Quotations",
					fontSize: 12,
					bold: true,
					marginTop: 15,
					marginBottom: 10,
					pageBreak: "before",
				});

				const quotationTableBody = [
					[
						{ text: "Vendor", bold: true },
						{ text: "Unit Price", bold: true },
						{ text: "Quantity", bold: true },
						{ text: "Total Amount", bold: true },
						{ text: "Description", bold: true },
						{ text: "Recommended", bold: true },
						{ text: "Delivery Time", bold: true },
					],
				];

				vendorQuotationsData.forEach((q) => {
					quotationTableBody.push([
						q.vendor || "",
						q.unitPrice || "",
						q.quantity || "",
						q.totalAmount || "",
						q.description || "",
						q.recommended ? "Yes" : "No",
						q.deliveryTime
							? moment(q.deliveryTime).format("DD/MM/YYYY")
							: "",
					]);
				});

				docContent.push({
					layout: "lightHorizontalLines",
					table: {
						widths: ["14.28%", "14.28%", "14.28%", "14.28%", "14.28%", "14.28%", "14.28%"],
						body: quotationTableBody,
					},
					marginBottom: 15,
				});
			}

			// Tag Assets Section
			if (tagAssetsData.length > 0) {
				docContent.push({
					text: "Tag Assets",
					fontSize: 12,
					bold: true,
					marginTop: 15,
					marginBottom: 10,
					
				});

				const assetsTableBody = [
					[
						{ text: "Asset Code", bold: true },
						{ text: "Category", bold: true },
						{ text: "Description", bold: true },
						{ text: "Serial Number", bold: true },
					
					],
				];

				tagAssetsData.forEach((a) => {
					assetsTableBody.push([
						a.assetCode || "",
					a.category || "",
					a.description || "",
					a.serialNo || "",
					
				]);
			});

			docContent.push({
				layout: "lightHorizontalLines",
				table: {
					widths: ["10%", "10%", "50%", "20%"],
					body: assetsTableBody,
			},
			marginBottom: 15,
		});
	}

	// Create PDF document
	const docDefinition = {
		content: docContent,
		styles: {
			header: {
				fontSize: 14,
				bold: true,
				margin: [0, 0, 0, 10],
			},
		},
		pageMargins: [40, 40, 40, 40],
	};

	// Generate filename with timestamp
	const fileName = `ItemRequisition_${id}_${moment().format("DDMMYYYY_HHmmss")}.pdf`;

	// Generate and download PDF
	pdfMake.createPdf(docDefinition).download(fileName);

	AlertPopups.successAlert.fire({
		text: "PDF downloaded successfully",
	});
	} catch (error) {
		console.error("Error downloading PDF:", error);
		AlertPopups.errorAlert.fire({
			text: "Error downloading PDF. Please try again.",
		});
	}
};

return (
	<UserConsumer>
		{(userDetails) => {
			token = userDetails.token;
			return userDetails.id.toString() === "40" ||
					userDetails.id.toString() === "51" || //Jibran
					userDetails.id.toString() === "33" ||
					userDetails.id.toString() === "79" ||
					userDetails.empRole.includes("3") ||
					userDetails.designation.toString() === "4" || // CM designation
					userDetails.department.toString() === "3" ? (
					<>
						<div className="container-fluid pl-3 pr-3">
							<Row className=" mb-3">
								<Col
									className="justify-content-between"
									lg={12}
								>
									<FormStatus
										id={id}
										formStatus={formItemStatus}
										className="create-request d-flex align-items-center"
										onClick={() => {
											history.push(
												Routes.ItemRequisition
											);
										}}
										navigateBack={true}
									/>
								</Col>
							</Row>
							<div className="d-flex justify-content-end mb-3">
								<Button
									color="success"
									outline
									onClick={handleDownloadPDF}
									className="mr-2"
									disabled={!ItemRequisitionDetail.employeeName}
								>
									Download PDF
								</Button>
							</div>
							<div className="formInfoContainer">
								<div className="formInfoContainerHeader">
									<Label sm={12}>Personal Information</Label>
								</div>
								<Col>
									<Row className="py-2 px-2">
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Employee Name</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													ItemRequisitionDetail.employeeName
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Employee Code</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													ItemRequisitionDetail.employeeCode
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Department</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													ItemRequisitionDetail.department
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Date</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{moment(
													ItemRequisitionDetail.date
												).format("DD/MM/YYYY ")}
											</p>
										</Col>
									</Row>
								</Col>
							</div>

							<div className=" my-4 formInfoContainer">
								<div className="formInfoContainerHeader">
									<Label sm={12}>Request Details</Label>
								</div>

								<Row className="py-2 px-4">
									<Col md={12} lg={3}>
										<div className="formDetailHeader">
											<div>Project/Department Name</div>
										</div>
									</Col>
									<Col md={12} lg={3}>
										<p className="formValueContainer">
											{ItemRequisitionDetail.projectName}
										</p>
									</Col>
									<Col md={12} lg={3}>
										<div className="formDetailHeader">
											<div>Item</div>
										</div>
									</Col>
									<Col md={12} lg={3}>
										<p className="formValueContainer">
											{ItemRequisitionDetail.item}
										</p>
									</Col>
									<Col md={12} lg={3}>
										<div className="formDetailHeader">
											<div>Req. Priority</div>
										</div>
									</Col>
									<Col md={12} lg={3}>
										<p className="formValueContainer">
											{ItemRequisitionDetail.priority}
										</p>
									</Col>
									<Col md={12} lg={3}>
										<div className="formDetailHeader">
											<div>Description</div>
										</div>
									</Col>
									<Col md={12} lg={3}>
										<p className="formValueContainer">
											{ItemRequisitionDetail.description}
										</p>
									</Col>
									<Col md={12} lg={3}>
										<div className="formDetailHeader">
											<div>Please justify the need</div>
										</div>
									</Col>
									<Col md={12} lg={3}>
										<p className="formValueContainer">
											{
												ItemRequisitionDetail.justification
											}
										</p>
									</Col>
								</Row>
							</div>

							{formItemStatus != "Pending" ? (
								<>
									<div className="my-4">
										<div className=" my-4 formInfoContainer">
											<div className="formInfoContainerHeader">
												<Label sm={8}>
													Relevant Department
												</Label>
											</div>

											<Formik
												enableReinitialize={true}
												initialValues={
													{
														// requestType: selectedRequestedType,
														// adminSupportApproval:
														//   selectedAdminSupportApprovalType,
													}
												}
												validationSchema={validate}
												validateOnChange={true}
												onSubmit={() => {}}
											>
												{({ errors, handleSubmit }) => (
													<Form>
														<Row className="py-2 px-4">
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		Request
																		Type
																	</div>
																</div>
															</Col>
															<Col md={12} lg={3}>
																<CustomReactSelect
																	options={
																		requestTypesList
																	}
																	value={
																		selectedRequestedType
																	}
																	onChange={(
																		value
																	) =>
																		setSelectedRequestType(
																			value
																		)
																	}
																	className={`supDesciptionBox ${
																		errors.requestType
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																/>
															</Col>
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		Item
																		Category
																	</div>
																</div>
															</Col>
															<Col md={12} lg={3}>
																<CustomReactSelect
																	options={
																		itemCategoryList
																	}
																	value={
																		selectedItemCategory
																	}
																	onChange={(
																		value
																	) => {
																		getRespondingVendors(
																			value
																		);
																	}}
																	className={`supDesciptionBox`}
																/>
															</Col>

															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		Admin/Support
																		Approval
																	</div>
																</div>
															</Col>
															<Col
																md={12}
																lg={3}
																className="my-1"
															>
																<CustomReactSelect
																	options={
																		adminSupportApprovalTypesList
																	}
																	value={
																		selectedAdminSupportApprovalType
																	}
																	onChange={(
																		value
																	) =>
																		setSelectedAdminSupportApprovalType(
																			value
																		)
																	}
																	className={`supDesciptionBox ${
																		errors.adminSupportApproval
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																/>
															</Col>
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		In Stock
																	</div>
																</div>
															</Col>
															<Col md={12} lg={3}>
																<Input
																	className="ml-2 mt-3 checkboxInput"
																	type="checkbox"
																	defaultChecked={
																		inStock
																	}
																	value={
																		inStock
																	}
																	onClick={() => {
																		setInStock(
																			!inStock
																		);
																		setShowVendorQuotations(
																			!showVendorQuotations
																		);
																		setIsVendorLoaded(
																			false
																		);
																	}}
																/>
															</Col>
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		Department
																		Comments
																	</div>
																</div>
															</Col>
															<Col
																md={12}
																lg={3}
																className="my-1"
															>
																<Input
																	type="textarea"
																	name="supervisorComments"
																	className={`formValueInput ${
																		errors.supervisorComments
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																	onChange={(
																		event
																	) =>
																		setSupervisorComments(
																			event
																				.target
																				.value
																		)
																	}
																	value={
																		supervisorComments
																	}
																	maxLength="400"
																/>
															</Col>
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		Vendor
																		Qualification
																		Remarks
																	</div>
																</div>
															</Col>
															<Col
																md={12}
																lg={3}
																className="my-1"
															>
																<Input
																	type="textarea"
																	className={`formValueInput ${
																		errors.supervisorComments
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																	onChange={(
																		event
																	) =>
																		setVendorQualificationRemarks(
																			event
																				.target
																				.value
																		)
																	}
																	value={
																		vendorQualificationRemarks
																	}
																	maxLength="400"
																/>
															</Col>
														</Row>
														<div className="btns">
															<Button
																className="submit-btn leftBtn"
																onClick={
																	handleRelevantDeptUpdate
																}
															>
																Update
															</Button>
														</div>
													</Form>
												)}
											</Formik>
										</div>
									</div>

									{userDetails.designation.toString() ===
									"4" ? (
										<CMApprovalForm
											itemRequisitionId={id}
										/>
									) : null}

									{formItemStatus === "CM Approved" ? (
										<CMApprovalForm
											itemRequisitionId={id}
											disableForm={true}
										/>
									) : null}

									{showVendorQuotations ? (
										<div
											className="pt-5 formInfoContainer"
											style={{ backgroundColor: "white" }}
										>
											{isVendorLoaded ? (
												<div className="formInfoContainerHeader">
													<Label sm={8}>
														Vendor Quotations
													</Label>
													<FormHeaderButton
														title="Add New"
														icon={faPlus}
														Vendor={true}
														selectedItemCategory={
															selectedItemCategory
														}
														showModal={() => {
															setShowVendorModal(
																true
															);
														}}
													/>
												</div>
											) : null}
											<VendorQuotations
												categoryId={
													selectedItemCategory?.value
												}
												itemRequisitionId={id}
												vendorByCategoryList={
													vendorByCategoryList
												}
												selectedVendor={selectedVendor}
												setSelectedVendor={(value) =>
													setSelectedVendor(value)
												}
												setVendorByCategoryList={(
													value
												) =>
													setVendorByCategoryList(
														value
													)
												}
												onVendorChange={(value) =>
													setSelectedVendor(value)
												}
												showModal={showVendorModal}
												setShowModal={(value) =>
													setShowVendorModal(value)
												}
												setIsVendorLoaded={(value) =>
													setIsVendorLoaded(value)
												}
											/>
										</div>
									) : null}

									{formItemStatus != "Pending" && (
										<div
											className="pt-4 formInfoContainer"
											style={{ backgroundColor: "white" }}
										>
											<ItemReceivingForm
												ItemReceivingTypes={
													ItemReceivingTypes
												}
												itemReceivingSection={
													itemReceivingSection
												}
												itemHandleChange={
													itemHandleChange
												}
												handleStatus={handleStatus}
												updateItemReceivingSection={
													updateItemReceivingSection
												}
												formFields={formFields}
											/>
										</div>
									)}

									<div
										className="pt-5 formInfoContainer"
										style={{ backgroundColor: "white" }}
									>
										{isTagAssetLoaded ? (
											<div className="formInfoContainerHeader">
												<Label sm={8}>Tag Assets</Label>
												<FormHeaderButton
													title="Add New"
													icon={faPlus}
													onClick={
														setShowTagAssetModal
													}
												/>
											</div>
										) : null}
										{itemCategoryList && (
											<TagAssets
												categoryId={
													selectedItemCategory?.value
												}
												itemRequisitionId={id}
												itemCategoryList={
													itemCategoryList
												}
												selectedTagAssetCategory={
													selectedTagAssetCategory
												}
												setSelectedTagAssetCategory={
													setSelectedTagAssetCategory
												}
												onTagAssetCategoryChange={(
													value
												) =>
													onTagAssetCategoryChange(
														value
													)
												}
												assetCode={tagAssetCode}
												showModal={showTagAssetModal}
												setShowModal={(value) =>
													setShowTagAssetModal(value)
												}
												setIsTagAssetLoaded={(
													value
												) => {
													setIsTagAssetLoaded(value);
												}}
											/>
										)}
									</div>
								</>
							) : null}
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
}

export default SSNItemRequisitionDetail;
